import { FormGroup, ValidatorFn } from '@angular/forms';

export function CheckTezinaIsporuke(valueKey: string, uomKey: string): ValidatorFn {
  return (group: FormGroup): { [key: string]: any } | null => {
    const val = group.controls[valueKey]?.value;
    const uom = group.controls[uomKey]?.value;

    const hasVal = val !== null && val !== undefined && val !== '' && val !== 0;
    const hasUom = uom !== null && uom !== undefined && uom !== '';

    if (hasVal && !hasUom) {
      return { CheckTezinaIsporuke: { valid: false, message: 'EOPTREMNICA.TEZINAISPORUKE.VALIDATION' } };
    }
    return null;
  };
}

export function CheckZapreminaIsporuke(valueKey: string, uomKey: string): ValidatorFn {
  return (group: FormGroup): { [key: string]: any } | null => {
    const val = group.controls[valueKey]?.value;
    const uom = group.controls[uomKey]?.value;

    const hasVal = val !== null && val !== undefined && val !== '' && val !== 0;
    const hasUom = uom !== null && uom !== undefined && uom !== '';

    if (hasVal && !hasUom) {
      return { CheckZapreminaIsporuke: { valid: false, message: 'EOPTREMNICA.ZAPREMINAISPORUKE.VALIDATION' } };
    }
    return null;
  };
}
